import {
  ActivityFlowQualityMetricIcon,
  ActivityMetricIconBadge,
} from "../../../components/ActivityDetailMetricIcons";

export const SummaryMetric = ({
  label,
  value,
  detail,
  infoTip = null,
  icon = <ActivityFlowQualityMetricIcon />,
  inlineDetail = false,
}) => (
  <article className="bg-white border border-gray-300 rounded-xl flex min-w-0 min-h-[112px] gap-3">
    <ActivityMetricIconBadge>{icon}</ActivityMetricIconBadge>
    <div className="flex flex-1 flex-col justify-center min-w-0 py-4 pr-4">
      <div className="flex items-center gap-1.5 min-w-0">
        <p className="m-0 text-sm text-[#6B7280]">{label}</p>
        {infoTip}
      </div>
      {inlineDetail ? (
        <div className="mt-2 flex items-baseline justify-between gap-3 min-w-0">
          <div className="m-0 min-w-0 text-xl font-bold text-[#222222]">
            {value ?? "-"}
          </div>
          <p className="m-0 shrink-0 text-right text-xs italic text-[#6B7280]">
            {detail}
          </p>
        </div>
      ) : (
        <div className="m-0 mt-2 min-w-0 text-xl font-bold text-[#222222]">
          {value ?? "-"}
        </div>
      )}
      {detail && !inlineDetail ? (
        <p className="m-0 mt-1 text-xs text-[#6B7280]">{detail}</p>
      ) : null}
    </div>
  </article>
);
